<template>
  <error-content code="404" :desc="langMap.pageNotFound[lang]" :src="src"/>
</template>

<script>
import error404 from '@/assets/images/error-page/error-404.svg'
import errorContent from './error-content.vue'
import langMap from '@/utils/language';
import { mapState } from 'vuex';
export default {
  name: 'error_404',
  components: {
    errorContent
  },
  data () {
    return {
      langMap:langMap,
      src: error404
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
  },
}
</script>
